<template>
  <v-app
    :style="{
      'background-image': 'url(' + require('@/assets/Loginimage1.jpg') + ')',
    }"
    style="background-size: cover"
  >
    <v-container class="fill-height" fluid>
      <v-card class="mx-auto">
        <v-card-text>
          <div class="d-flex justify-center">
            <v-img
              max-width="200"
              max-height="150"
              contain
              src="@/assets/Assistanz_Logo.png"
            >
            </v-img>
          </div>
          <div class="d-flex justify-center mt-5">Let's get started</div>
          <div class="d-flex justify-center font-weight-bold mt-2">
            Registered phone number
          </div>
          <v-row class="mt-5">
            <v-col cols="4">
              <v-autocomplete
                label="ISO Code"
                v-model="userCCcode"
                :items="countryCodes"
                :search-input.sync="search"
                @input="search = ''"
                item-value="value"
                item-text="label"
                dense
                outlined
                :menu-props="{ offsetY: true, maxHeight: 200 }"
              >
                <template #selection="{ item }">
                  {{ item.value }}
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="8">
              <v-text-field
                outlined
                dense
                v-model="phoneNumber"
                label="Phone Number"
                v-on:keypress="is_Number($event)"
                maxlength="13"
              />
            </v-col>
          </v-row>
          <div v-if="otpVisible == 0">
            <div class="d-flex justify-center mt-n2" style="font-size: smaller">
              An OTP / Code will be sent to this phone number.
            </div>
            <v-btn
              block
              dark
              class="mt-4 elevation-0 text-capitalize cardCss"
              @click="nextFunction()"
              id="sign-in-button"
              :loading="loading1"
              >Send OTP/ Code
            </v-btn>
          </div>
          <div v-if="otpVisible == 1">
            <p><b>Enter the OTP / Code sent to your Phone Number.</b></p>
            <v-row justify="center">
              <v-col cols="12" style="max-width: 700px">
                <v-otp-input
                  v-model="otpInput"
                  length="6"
                  v-on:keypress="is_Number($event)"
                ></v-otp-input>
              </v-col>
            </v-row>
            <div v-if="timer > 0">{{ timer }} seconds remaining</div>
            <div v-if="timer === 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <p @click="nextFunction()" v-bind="attrs" v-on="on">
                    Resend
                    <v-icon color="red" dark> mdi-refresh-circle </v-icon>
                  </p>
                </template>
                <span>Resend </span>
              </v-tooltip>
            </div>
          </div>
          <div v-if="otpVisible == 1">
            <v-btn
              block
              dark
              class="mt-4 text-capitalize cardCss"
              :loading="loading1"
              @click="validate_sign_in()"
              >Login</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <SnackBar :SnackBarComponent="SnackBarComponent" />
  </v-app>
</template>

<script>
/* eslint-disable */
import { apicall } from "@/mixins/RestApi";
import SnackBar from "@/components/SnackBar.vue";
import CountryList from "@/JsonFiles/CountryList.json";
// import firebase from "firebase";

var axios = require("axios");
export default {
  mixins: [apicall],
  components: {
    SnackBar,
  },
  data() {
    return {
      phoneNumber: "",
      userCCcode: "",
      SnackBarComponent: {},
      search: "",
      otpInput: "",
      otpVisible: 0,
      loading1: false,
      countrySelected: "",
      countriesData: [],
      storeNumber: "",
      auth: "",
      confirmResult: "",
      height: 0,
      otpInput: "",
      timer: 0,
      sessiondata: "",
      resendDisabled: false,
    };
  },
  created() {
    this.height = window.innerHeight - 90;
    this.countries();
    // Now you can use 'auth' and other Firebase services in this component.
  },

  mounted() {
    const apiKey = "7dc7ae8d1cc54ab2ae3753110b2a7726";
    this.getTimezoneAndCountry(apiKey);
  },
  methods: {
    nextFunction() {
      if (this.phoneNumber == "") {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: "Enter Phone Number",
          timeout: 5000,
          Top: true,
        };
      } else {
        // this.$router.push("/Dashboard")
        this.send_msg();
        this.storeNumber = this.userCCcode + this.phoneNumber;
        this.$store.commit("SetphoneNumber", this.storeNumber);
        // this.otpVisible = 1;
      }
    },
    validate_sign_in() {
      if (this.otpInput.length == 0) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: "Enter OTP",
          timeout: 5000,
          Top: true,
        };
      } else if (this.otpInput.length != 6) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: "Invalid OTP",
          timeout: 5000,
          Top: true,
        };
      } else {
        // this.callcaptcha();
        this.logverify();
      }
      // this.otpVisible = 0;
    },
    callcaptcha() {
      this.loading1 = true;
      const code = this.otpInput;
      this.confirmResult
        .confirm(code)
        .then((result) => {
          this.loading1 = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            SnackbarText: "Login Successfully! ",
            timeout: 5000,
            Top: true,
          };
          this.$router.push("/Dashboard");
        })
        .catch((error) => {
          if (error) {
            this.otpInput = "";
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              SnackbarText: error,
              timeout: 5000,
              Top: true,
            };
          }
          this.loading1 = false;
        });
    },
    is_Number(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (this.phoneNumber.length >= 15) {
          evt.preventDefault();
        }
        return true;
      }
    },
    getTimezoneAndCountry(apiKey) {
      const url = `https://api.geoapify.com/v1/ipinfo?apiKey=${apiKey}`;

      axios
        .get(url)
        .then((response) => {
          const data = response.data;

          if (data) {
            // this.currentTimeZone = data.location.timezone;
            this.countrySelected = data.country.name;
            this.userCCcode = "+" + data.country.phone_code;

            this.getTimezone(
              apiKey,
              data.location.latitude,
              data.location.longitude
            );
          } else {
          }
        })
        .catch((error) => {
          // console.error("Error fetching geolocation data:", error);
        });
    },
    countries() {
      var countryWithCc = [];
      this.countriesData = [];
      CountryList.forEach((element) => {
        countryWithCc.push({
          label: `${element.name} (${element.dial_code})`,
          value: element.dial_code,
        });
        this.countriesData.push(element.name);
      });

      var countryListt = countryWithCc;
      this.countryCodes = countryListt;
    },
    async send_msg() {
      this.loading1 = true;
      let method_param = {
        full_contact_number: this.userCCcode + this.phoneNumber,
        command: "checkUserData",
      };
      var responseData = await this.apicall("validate_customer", method_param);

      if (responseData.data.Status == "SUCCESS") {
        this.loading1 = false;
        this.sendOtp();
      } else if (responseData.data.Status == "ERROR") {
        this.loading1 = false;
        this.phoneNumber = "";
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: responseData.data.Message,
          timeout: 5000,
          Top: true,
        };
      } else {
        this.loading1 = false;
      }
    },
    async logverify() {
      this.loading1 = true;
      let method_param = {
        customer_contact_number: this.userCCcode + this.phoneNumber,
        otp: this.otpInput,
        session: this.sessiondata,
      };
      var responseData = await this.apicall(
        "verify_otp_stichh_assistenz_users",
        method_param
      );
      if (responseData.data.Status == "SUCCESS") {
        this.sessiondata = "";
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          SnackbarText: "Login Successfully! ",
          timeout: 5000,
          Top: true,
        };

        this.loading1 = false;
        this.$router.push("/Dashboard");
      } else if (responseData.data.Status == "ERROR") {
        this.loading1 = false;

        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: responseData.data.Message,
          timeout: 5000,
          Top: true,
        };
      } else {
        this.loading1 = false;
      }
    },
    async sendOtp() {
      this.loading1 = true;
      let method_param = {
        customer_contact_number: this.userCCcode + this.phoneNumber,
      };
      var responseData = await this.apicall(
        "genrate_otp_stichh_assistenz_customers",
        method_param
      );
      if (responseData.data.Status == "SUCCESS") {
        this.sessiondata = "";
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          SnackbarText: responseData.data.Message,
          timeout: 5000,
          Top: true,
        };
        this.sessiondata = responseData.data.session;

        this.loading1 = false;
        this.starttimer();
        this.otpVisible = 1;
      } else if (responseData.data.Status == "ERROR") {
        this.loading1 = false;
        this.phoneNumber = "";
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: responseData.data.Message,
          timeout: 5000,
          Top: true,
        };
      } else {
        this.loading1 = false;
      }
    },
    // async callSubmit() {
    //   this.loading1 = true;
    //   firebase.auth().useDeviceLanguage();
    //   if (!this.recaptchaVerifier) {
    //     this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
    //       "sign-in-button",
    //       {
    //         size: "invisible",
    //         callback: (e) => {
    //           console.log(e);
    //         },
    //       }
    //     );
    //   }
    //   if (this.recaptchaWidgetId !== "") {
    //     this.recaptchaVerifier.render().then((widgetId) => {
    //       if (
    //         typeof grecaptcha !== "undefined" &&
    //         typeof grecaptcha.reset === "function"
    //       ) {
    //         grecaptcha.reset(widgetId);
    //       }
    //       this.recaptchaWidgetId = widgetId;
    //     });
    //   } else {
    //     this.recaptchaVerifier.render().then((widgetId) => {
    //       this.recaptchaWidgetId = widgetId;
    //     });
    //   }
    //   this.confirmResult = "";
    //   const phoneNumber =
    //     (this.userCCcode.toString().includes("+") == false
    //       ? "+" + this.userCCcode
    //       : this.userCCcode) + this.phoneNumber;
    //   firebase
    //     .auth()
    //     .signInWithPhoneNumber(phoneNumber, this.recaptchaVerifier)
    //     .then((confirmationResult) => {
    //       this.confirmResult = confirmationResult;
    //       this.SnackBarComponent = {
    //         SnackbarVmodel: true,
    //         SnackbarColor: "green",
    //         SnackbarText: "OTP Sent Successfully",
    //         timeout: 5000,
    //         Top: true,
    //       };
    //       this.loading1 = false;
    //       this.starttimer();
    //       this.otpVisible = 1;
    //     })
    //     .catch((error) => {
    //       console.log("errr", error);
    //       this.loading1 = false;
    //       this.phoneNumber = "";
    //       this.SnackBarComponent = {
    //         SnackbarVmodel: true,
    //         SnackbarColor: "red",
    //         SnackbarText: error,
    //         timeout: 5000,
    //         Top: true,
    //       };
    //       this.recaptchaWidgetId = "";
    //       this.loading1 = false;
    //     });
    // },
    starttimer() {
      // Disable the Resend OTP button during the timer
      this.resendDisabled = true;

      // Set the timer to 60 seconds (1 minute)
      this.timer = 60;

      // Start the countdown
      const countdown = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          this.resendDisabled = false;
          clearInterval(countdown); // Stop the countdown
        }
      }, 1000);
    },
  },
};
</script>
<style scoped>
/* Add CSS for background image */
.login-card {
  background-image: url("@/assets/Loginimage1.jpg");
  /* Replace with your image URL */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
